import fetchApi from "../fetchApi";
import { DEFAULT_LIMIT } from "../../contstants";
export const GetProgramReports = async (
  id,
  limit = DEFAULT_LIMIT,
  offset = 0,
) => {
  const options = {
    method: "GET",
    headers: new Headers({
      "Content-Type": "application/json",
    }),
    redirect: "follow",
  };

  return await fetchApi(
    `card-issuing/company/program-report/${id}/reporting?limit=${limit}&offset=${offset}`,
    options
  );
};
